// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__RwTtl","modalForm":"UpgradeEpcsModal_modalForm__18LjS","modalFooter":"UpgradeEpcsModal_modalFooter__d6WLi"};